module.exports = __webpack_public_path__ + "static/img/process.6354548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gene_second/PCR_cloning/process.png
// module id = 8nwM
// module chunks = 16